// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".GNKqvUyyTR4fXHO27Va7xw\\=\\= {\n  color: var(--white);\n  font-weight: 300;\n  letter-spacing: 1px;\n  cursor: pointer;\n}", "",{"version":3,"sources":["webpack://src/devlink/MenuLink.module.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".menu-link {\n  color: var(--white);\n  font-weight: 300;\n  letter-spacing: 1px;\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"menu-link": "GNKqvUyyTR4fXHO27Va7xw=="
};
export default ___CSS_LOADER_EXPORT___;
